import { useState } from "react";
import { X, Plus } from "lucide-react";
import { useT } from "@/i18n";

export default function TagInput({ value = [], onChange, placeholder, testid = "tag-input", color = "var(--primary)" }) {
  const { t } = useT();
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (!value.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...value, v].slice(0, 30));
    setDraft("");
  };

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); }
  };

  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {value.map((tag) => (
          <span key={tag} className="inline-flex items-center gap-1 pl-3 pr-1.5 py-1 rounded-full text-xs font-medium text-white" style={{ background: color }} data-testid={`${testid}-tag`}>
            {tag}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== tag))} className="w-4 h-4 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/40"><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={onKey} onBlur={add}
          className="deuro-input py-2.5" placeholder={placeholder || t("tag_ph")} data-testid={`${testid}-field`} />
        <button type="button" onClick={add} className="px-3 rounded-xl border-2 border-[#e5dfd3] hover:border-[#1e3326]" data-testid={`${testid}-add`}><Plus className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
